import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async'; // <-- IMPORT

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* AuthProvider wraps the whole app */}
    <AuthProvider> 
      <HelmetProvider> {/* <-- WRAP YOUR APP */}
        <App />
      </HelmetProvider>
    </AuthProvider>
  </React.StrictMode>
);